import React from 'react';
import { observer } from 'mobx-react-lite';
import { doBetStore } from '../../../../store';
import { globalTranslationKeys } from '../../../../enums';

const BetButtonSection = observer(
  ({ t, isLoadingBetButton, decidedCallBackCall, isBetsClosed, activeFreeBet }) => {
    const { currentOdd } = doBetStore;
    const isValidFreeBetOdd = activeFreeBet.minOdd ? currentOdd >= activeFreeBet.minOdd : true;
    const { Bet, MinOdd, FreeBet } = globalTranslationKeys;
    return (
      <div
        title={t(globalTranslationKeys.Bet)}
        className={`monti-bet-button-holder ${isLoadingBetButton ? 'bet-loading' : ''} ${
          isBetsClosed || !isValidFreeBetOdd ? 'disabled' : ''
        }`}
        onClick={() => decidedCallBackCall(doBetStore.doBetSender)}
      >
        <div
          className={`monti-bet-button ${!isBetsClosed && isValidFreeBetOdd ? 'pulse-anim' : ''}`}
        >
          <div className='monti-bet-button-inside'>
            <p className='monti-bet-button-txt'>
              {activeFreeBet?.id ? `${t(FreeBet)} ${activeFreeBet?.remainingCount}` : t(Bet)}
            </p>
            {isLoadingBetButton && <span className='circle-loader' />}
            {activeFreeBet?.id && !activeFreeBet.isMinOddNull && (
              <p className='mont-bet-min-odd-txt'>
                {activeFreeBet?.id ? `${t(MinOdd)} x${activeFreeBet?.minOdd}` : null}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
);

export default BetButtonSection;
